/** 다중 선택 드롭다운 값 구분자 (저장·표시 공통) */
export const SPEC_DROPDOWN_VALUE_SEP = ', ';

export const parseSpecDropdownMultiValue = (raw) => {
    const s = String(raw ?? '').trim();
    if (!s) {
        return [];
    }
    return s.split(SPEC_DROPDOWN_VALUE_SEP).map((p) => p.trim()).filter(Boolean);
};

export const formatSpecDropdownMultiValue = (values) => {
    const unique = [];
    const seen = new Set();
    (Array.isArray(values) ? values : []).forEach((v) => {
        const t = String(v ?? '').trim();
        if (t && !seen.has(t)) {
            seen.add(t);
            unique.push(t);
        }
    });
    return unique.join(SPEC_DROPDOWN_VALUE_SEP);
};

/**
 * @param {string} raw
 * @param {Set<string>} optionValuesSet
 * @returns {{ selected: string[], legacyWhole: string|null }}
 */
export const getSpecDropdownSelectionState = (raw, optionValuesSet) => {
    const s = String(raw ?? '').trim();
    if (!s) {
        return { selected: [], legacyWhole: null };
    }
    if (optionValuesSet.has(s)) {
        return { selected: [s], legacyWhole: null };
    }
    const parts = parseSpecDropdownMultiValue(s);
    if (parts.length > 0 && parts.every((p) => optionValuesSet.has(p))) {
        return { selected: parts, legacyWhole: null };
    }
    if (parts.length === 1 && !optionValuesSet.has(parts[0])) {
        return { selected: [], legacyWhole: s };
    }
    const known = parts.filter((p) => optionValuesSet.has(p));
    if (known.length > 0) {
        return { selected: known, legacyWhole: null };
    }
    return { selected: [], legacyWhole: s };
};
